<template lang="pug">
  el-container(class='auth')
    el-main
      .auth__form
        h1(class='form__title') Авторизация
        el-form(:model='form' :rules='rules' ref='form' @submit='submit')
          el-form-item(v-if="!operatorIsSet" prop='operator_short_name' label='Оператор')
            el-input(id='login' v-model='form.operator_short_name')
          el-form-item(prop='login' label='Логин')
            el-input(id='login' v-model='form.login')
          el-form-item(prop='password' label='Пароль')
            el-input(id='password' v-model='form.password' type='password')
          el-form-item
            el-button(id='submit' :disabled='isDisabled' type='primary' native-type='submit' @click='submit') Войти
    el-footer.auth__footer &copy; GoodLine 2019
</template>

<script>
import { mapActions } from "vuex";
import { required } from "@/core/helpers/validators";

export default {
  name: "Auth",
  data() {
    return {
      form: { login: "", password: "", operator_short_name: process.env.VUE_APP_OPERATOR_SHORT_NAME || "" },
      rules: {
        login: [required()],
        password: [required()],
        operator_short_name: [required()],
      },
    };
  },
  computed: {
    isDisabled() {
      return !(this.form.login.length > 0 && this.form.password.length > 0);
    },
    operatorIsSet() {
      return !!process.env.VUE_APP_OPERATOR_SHORT_NAME;
    },
  },
  methods: {
    ...mapActions("auth", { getToken: "GET_TOKEN" }),
    submit(event) {
      event.preventDefault();

      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.getToken(this.form)
            .then(() => {
              this.$router.replace({ name: "dashboard" });
            })
            .catch(({ response }) => {
              this.$message({
                message: response.data.error,
                type: "error",
              });
            });
        }
        return valid;
      });
    },
  },
};
</script>

<style>
.auth {
  position: relative;
  background-color: #e6ebf5;
  height: 100vh;
}
.auth__form {
  position: absolute;
  top: calc(50% - 60px);
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  width: 380px;
}
.auth .form__title {
  font-size: 20px;
}
.auth__footer {
  background-color: #fff;
  line-height: 60px;
  text-align: center;
}
</style>
